import iconPrediction from "assets/img/icons/craft-prediction.svg";
import { usePopup } from "hooks/usePopup";
import { useSoundPath } from "hooks/useSoundPath";
import { useDispatch } from "react-redux";
import { getBalanceRequest } from "store/thunks";

const ActiveItemRedeem = () => {
  const dispatch = useDispatch();
  const setPopupHook = usePopup();
  const playSound = useSoundPath();

  const redeemPrizeHandler = () => {
    dispatch(getBalanceRequest());
    setPopupHook({type: 'redeem-prize'});
    playSound('main')
  }

  return (
    <button className="card-details__button card-details__button--craft" onClick={redeemPrizeHandler}>
      <img src={iconPrediction} alt="" />
      Redeem Prize
    </button>
  )
}

export default ActiveItemRedeem
